function openIngredientsModal() {
  const INGREDIENTS_MODAL_WIDTH = "400px";
  const INGREDIENTS_MODAL_HEIGHT = "auto";

  const modalReference = openModal(
    INGREDIENTS_MODAL_WIDTH,
    INGREDIENTS_MODAL_HEIGHT,
  );

  modalReference.classList.add("ingredients-modal", "p-4");

  const titleElem = document.createElement("h4");
  titleElem.classList.add("text-uppercase", "mb-3");
  titleElem.innerText = "Parfum - Wild Fig and Gardenia";

  const ingredientsList = document.createElement("p");
  ingredientsList.classList.add("text-darker-secondary", "small");
  ingredientsList.innerText = "Ethanol (Alcohol Denat), Parfum (Fragrance), Gardenia Gradiflora (Gardenia) Flower Oil, Ficus Carica (Fig) Fruit Oil, Heliotrope Flower Oil, Dipteryx Odorata (Tonka) Bean Oil, Santalum Album (Sandalwood) Oil, Citral*, Benzyl Benzoate*, Tetramethyl Acetyloctahydronaphthalenes*, Hydroxycitronellal*, Acetyl Cedrene*, Citronellol*, Limonene*, Eugenol*, Hexamethylindanopyran*, Pogostemon Cablin Oil*, Coumarin*, Linalool*, Geraniol*";

  modalReference.appendChild(titleElem);
  modalReference.appendChild(ingredientsList);
}